
export function sample<T>(wordlist: T[]): T{
    const index = Math.floor(Math.random() * wordlist.length)
    return wordlist[index]
}

export function sampleN<T>(wordlist: T[], n:number): T[]{
    const result: T[] = []
    const source = [...wordlist]
    for(let i = 0; i < n; i++){
        const index = Math.floor(Math.random() * source.length)
        result.push(source[index])
        source.splice(index, 1)
    }
    return result
}

export function shuffle<T>(array: T[]): T[] {
    const newArray = [];
    while(array.length > 0){
        const index = Math.floor(Math.random() * array.length)
        newArray.push(array[index])
        array = array.filter((_, i)=>i !== index)
    }
    return newArray
}